import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/GLB_Oxxo_V4.glb";
import planeactvtwo from "../../../../../assets/models/subtopictwo/planeForActivityTwo.glb";
import { GUI } from "dat.gui";
import gsap from "gsap";
export class MapSubtopicTwo extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);
		// this.rotation.y = MathUtils.degToRad(90)
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.Gondola_3 = gltf.scene.getObjectByName("Gondola_3", true);
			this.Gondola_2 = gltf.scene.getObjectByName("Gondola_2", true);

			this.Jugo_43 = gltf.scene.getObjectByName("Jugo_43", true);
			this.Jugo_12 = gltf.scene.getObjectByName("Jugo_26", true);
			this.Suero_1 = gltf.scene.getObjectByName("Suero_1", true);
			this.cafe_2 = gltf.scene.getObjectByName("cafe_2", true);

			// fondeoActv
			this.Refresco_22001 = gltf.scene.getObjectByName("Refresco_22001", true);
			this.Refresco_22 = gltf.scene.getObjectByName("Refresco_22", true);
			this.Gatorade_1001 = gltf.scene.getObjectByName("Gatorade_1001", true);
			this.Gatorade_1 = gltf.scene.getObjectByName("Gatorade_1", true);
			this.Jugo_36001 = gltf.scene.getObjectByName("Jugo_36001", true);
			this.Jugo_36 = gltf.scene.getObjectByName("Jugo_36", true);
			this.Jugo_23001 = gltf.scene.getObjectByName("Jugo_23001", true);
			this.Jugo_23 = gltf.scene.getObjectByName("Jugo_23", true);

			this.Mostrador001 = gltf.scene.getObjectByName("Mostrador001", true);
			this.Piso = gltf.scene.getObjectByName("Piso", true);
			this.Techo = gltf.scene.getObjectByName("Techo", true);
			this.Paredes = gltf.scene.getObjectByName("Paredes", true);
			this.Refri_coca_1 = gltf.scene.getObjectByName("Refri_coca_1", true);
			this.Estructura001 = gltf.scene.getObjectByName("Estructura001", true);
			this.Yelox = gltf.scene.getObjectByName("Yelox", true);
			this.Helado = gltf.scene.getObjectByName("Helado", true);

			const newMaterialPiso = this.Piso.material.clone();
			newMaterialPiso.color.set(0xd6d6d6);
			newMaterialPiso.emissiveIntensity = 2;
			newMaterialPiso.emissive.set("#2E2E2E");
			this.Piso.material = newMaterialPiso;
			const newMaterialTecho = this.Techo.material.clone();
			newMaterialTecho.color.set(0xffffff);
			newMaterialTecho.emissiveIntensity = 2;
			newMaterialTecho.emissive.set("#595959");
			this.Techo.material = newMaterialTecho;
			const newMaterialHelado = this.Helado.material.clone();
			newMaterialHelado.color.set(0xd1d1d1);
			newMaterialHelado.emissiveIntensity = 3.6;
			newMaterialHelado.emissive.set("#5E5E5E");
			this.Helado.material = newMaterialHelado;

			this.Paredes.material.emissiveIntensity = 2;
			this.Refri_coca_1.material.emissiveIntensity = 0.98;
			this.Yelox.material.emissiveIntensity = 2.58;
			this.Estructura001.material.emissive.set("#595959");
			this.Estructura001.material.emissiveIntensity = 1;
			this.Mostrador001.material.emissive.set("#737373");
			this.Mostrador001.material.emissiveIntensity = 2;
		});
		loader.load(planeactvtwo, (gltf) => {
			this.add(gltf.scene);
			this.planeForActivityTwo = gltf.scene.getObjectByName("Plane", true);
			this.Plane_fondeo = gltf.scene.getObjectByName("Plane-fondeo", true);
			this.Plane_fondeo.visible = false;

			this.Box_1 = gltf.scene.getObjectByName("Box-1", true);
			this.Box_2 = gltf.scene.getObjectByName("Box-2", true);
			this.Box_3 = gltf.scene.getObjectByName("Box-3", true);
			this.Box_4 = gltf.scene.getObjectByName("Box-4", true);

			this.Box_2fondeo = gltf.scene.getObjectByName("Box-2fondeo", true);
			this.Box_1fondeo = gltf.scene.getObjectByName("Box-1fondeo", true);
			this.Box_3fondeo = gltf.scene.getObjectByName("Box-3fondeo", true);
			this.Box_4fondeo = gltf.scene.getObjectByName("Box-4fondeo", true);

			this.onVisibleCubesActvTwo(false);
			this.onVisibleCubesActvTwoFondeo(false);

			this.planeForActivityTwo.position.z += 0.1;
			// this.Plane_fondeo.position.z += 0.28;
			this.planeForActivityTwo.position.x += 0.1;
			this.planeForActivityTwo.visible = false;

			this.positionBoxAll = {
				Box_1: this.Box_1.position.clone(),
				Box_2: this.Box_2.position.clone(),
				Box_3: this.Box_3.position.clone(),
				Box_4: this.Box_4.position.clone(),
				Box_2fondeo: this.Box_2fondeo.position.clone(),
				Box_1fondeo: this.Box_1fondeo.position.clone(),
				Box_3fondeo: this.Box_3fondeo.position.clone(),
				Box_4fondeo: this.Box_4fondeo.position.clone(),
			}
		});
	}

	positionBoxSet() {
		Object.entries(this.positionBoxAll).forEach(([key, value]) => {
			this[key].position.copy(value);
		})
	}

	onVisibleCubesActvTwo(visible) {
		this.Box_1.visible = visible;
		this.Box_2.visible = visible;
		this.Box_3.visible = visible;
		this.Box_4.visible = visible;
	}
	onVisibleCubesActvTwoFondeo(visible) {
		this.Box_2fondeo.visible = visible;
		this.Box_1fondeo.visible = visible;
		this.Box_3fondeo.visible = visible;
		this.Box_4fondeo.visible = visible;
	}

	onHiddenActTwo() {
		this.Gondola_2.visible = false;
	}

	onHiddenGondolasActivityOne() {
		this.Gondola_2.visible = false;
		this.Gondola_3.visible = false;
	}
	onShowGondolasDefault() {
		this.Gondola_2.visible = true;
		this.Gondola_3.visible = true;
	}

	onStatusActivityTwo() {
		this.Jugo_43.position.set(29, 155.1219, 44.8436);
		this.Jugo_12.position.set(17, 166.1497, 55.8715);
		this.Suero_1.position.set(28, 166.1497, 50);
		this.cafe_2.position.set(17, 155.1219, 44);
	}

	statusActvTwoFondeo() {
		this.Jugo_23001.position.set(20, 140, -10.2955);
		this.Jugo_36001.position.set(31, 146, -13);
		this.Refresco_22001.position.set(22.788, 147, 0.7323);
		this.Gatorade_1001.position.set(15, 144, 0.7323);

		this.Plane_fondeo.visible = false;
	}

	onAnimate(object) {
		if (this.animation) {
			this.animation.kill();
		}

		if (this.objectActiveAnimation) {
			this.objectActiveAnimation.material.emissiveIntensity = 1
			this.objectActiveAnimation = null
		}

		if (!object) {
			return
		}

		const newMaterial = object.material.clone();
		object.material = newMaterial;

		this.objectActiveAnimation = object
		// object.material.material.emissive.set("#404040");

		this.animation = gsap.to(object.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	helpersChild() {
		this.helperMethod("Refresco_22001", this.Refresco_22001);
		this.helperMethod("Gatorade_1001", this.Gatorade_1001);
		this.helperMethod("Jugo_36001", this.Jugo_36001);
		this.helperMethod("Jugo_23001", this.Jugo_23001);
	}

	helperMethod(name, object) {
		const { position, rotation } = object;
		const gui = new GUI();
		const folferMostrador = gui.addFolder(name);
		const limit = 500;
		folferMostrador.add(position, "x", -limit, limit).step(0.0001).name("Posición X");
		folferMostrador.add(position, "y", -limit, limit).step(0.0001).name("Posición Y");
		folferMostrador.add(position, "z", -limit, limit).step(0.0001).name("Posición Z");
		folferMostrador.add(rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folferMostrador.add(rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folferMostrador.add(rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folferMostrador.add(object, "visible").name("Visible");

		folferMostrador
			.addColor({ color: object.material.color.getHex() }, "color")
			.name("Color del Material")
			.onChange((value) => {
				object.material.color.set(value);
			});

		folferMostrador
			.add(object.material, "emissiveIntensity", 0, 5)
			.name("Intensidad de Emisión")
			.onChange(function (intensity) {
				object.material.emissiveIntensity = intensity;
			});

		const emissiveControl = folferMostrador.addColor({ emissive: object.material.emissive.getHex() }, "emissive").name("Color de Emisión");
		emissiveControl.onChange(function (color) {
			object.material.emissive.set(color);
		});
	}

	renderAnimations() { }
}
